import { useEffect, useRef } from 'react';
import { useIsMobileDimension } from '@carnica/utils/hooks';
export var useTopBarColor = function useTopBarColor(color) {
  var isActive = useIsMobileDimension();
  var element = useRef();
  useEffect(function () {
    var _meta;
    var meta = document.querySelector('meta[name="theme-color"]');
    var previousColor = (_meta = meta) === null || _meta === void 0 ? void 0 : _meta.content;
    if (isActive) {
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'theme-color';
        document.getElementsByTagName('head')[0].appendChild(meta);
      }
      meta.content = color;
      element.current = meta;
    }
    return function () {
      if (!element.current) {
        return;
      }
      if (!previousColor) {
        var _element$current;
        (_element$current = element.current) === null || _element$current === void 0 ? void 0 : _element$current.remove();
        return;
      }
      element.current.content = previousColor;
    };
  }, [color, isActive]);
};